<template>
    <div v-if="isShow" :style="domStyle" class="appMenu">
        <div>
            <ul>
                <li
                    v-for="item in this.urlLst"
                    :key="item.index"
                    :uuid="item.uuid"
                    :title="item.varName"
                    @click="onGetData(item)"
                >
                    <img class="images" :src="item.varSrc" alt=""/>
                    <div class="text">{{ item.varName }}</div>
                </li>
            </ul>
        </div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name: 'AppMenu',
    props: ['primitives', 'fvSystemApi', 'parentObject'],
    created () {
        // 组件数据混淆
        this.mixin(this.primitives);
        // 组件大小位置初始化
        this.domStyle = {
            position: 'absolute',
            left: this.x + 'px',
            top: this.y + 'px',
            width: this.parentObject.width + 'px',
            overflow: 'auto'
        };
        this.enableStyle = {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '0px',
            backgroundColor: '#ccbfbf',
            opacity: '0.5',
        };
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath, {
            state: {
                $: this,
            },
        });
        if (this.OnCick && this.OnCick != '%OnClick%') {
            this.OnCick = AsyncFunction('param', this.OnCiclk);
        }
    },
    mounted() {
        this.isShow = false;
        this.isShow = true;
    },
    data () {
        return {
            // 是否可用
            isEnable: false,
            // 是否显示
            isShow: true,
            // 组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle: {},
            headerStyle: {},
            // 版本号
            version: '10.0.3.1',
        };
    },
    computed: {},
    methods: {
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin (src) {
            for (var key in src) {
                this[key] = src[key];
            }
        },
        onGetData (data) {
            if (typeof this.OnCick == 'function') {
                this.fvSystemApi.executionScript(this.OnCick, data.name);
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent (e, domScale) {
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer () {
            if (this.isEnable) return;
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose () {
            return new Promise((resolve) => {
                resolve();
            });
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw (scaleObj) {
            this.domStyle.left = parseInt(this.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) + 'px';
            this.domStyle.top = parseInt(this.y * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + scaleObj.titleHeight + 'px';
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + 'px';
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + 'px';
            // 根据款靠适应宽度， 目前只有5个
            // for ( var i = 0; i < this.$el.children[0].children[0].children.length; i++) {
            //     // this.$el.children[0].children[0].children[i].style.width = parseInt(this.domStyle.width) / 4 + 'px';
            //     // this.$el.children[0].children[0].children[i].style.height = parseInt(this.domStyle.width) / 4 + 'px';
            // }
            // parseInt(this.width * (scaleObj.sx + scaleObj.zoom))/5;
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show (isShow) {
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable (isEnable) {
            this.isEnable = isEnable ? false : true;
        },
    },
};
</script>

<style lang="less">
* {
    box-sizing: border-box;
}

.appMenu ul {
    margin: 0;
    font-size: 12px;
    list-style: none; /*清除列表默认样式*/
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
}

.appMenu ul li {
    margin: 0 5px 5px;
    text-align: center;
    cursor: pointer;

    .images {
        width: 65px;
        height: 65px;
        border: 1px solid #cfcbcb;
        border-radius: 16px;
    }

    .text {
        font-size: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvAppMenu/fvAppMenu.vue